import {
  Option,
  RenderOptions,
  Value,
} from 'components/base/Form/Input/types'

export interface Props {
  alwaysShowError?: boolean,
  createdByCorrectParent?: boolean,
  defaultValue?: Value,
  direction?: Direction,
  error?: string,
  isChecked?: boolean,
  loaded?: boolean,
  loading?: boolean,
  name?: string,
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void,
  options?: Option[],
  renderOptions?: RenderOptions,
  showLoading?: boolean,
  showLoadingError?: boolean,
  touched?: boolean,
  valid?: boolean,
  value?: Value,
}

export enum Direction {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
